import { useEffect } from "react";
import About from "./About";
import FeaturesSection from "./FeaturesSection";
import FooterSection from "./FooterSection";
import HeroSection from "./HeroSection";
import HowItsWorkSection from "./HowItsWorkSection";
import PricingSection from "./PricingSection";
import { StyledLandingPage } from "./styles";
import TopBar from "./Topbar";
import { useLocation } from "react-router-dom";
import WhyKelu from "./WhyKelu";

const Landing = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://widget.kelu.uk/?clientId=04c2910f-708c-43cf-bcbb-a444cc155901";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // @ts-ignore
      if (window?.KeluAiChatWidget) window.KeluAiChatWidget?.destroy();
    };
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  }, [location]);

  return (
    <StyledLandingPage className="flex-col align-center">
      <TopBar />
      <div className="content-div">
        <HeroSection />
        <WhyKelu />
        <FeaturesSection />
        <HowItsWorkSection />
        <PricingSection />
        <About />
        <FooterSection />
      </div>
    </StyledLandingPage>
  );
};

export default Landing;
